
import React from 'react';

export const ExperienceSection: React.FC = () => {
  const experiences = [
    {
      title: "Refresh and leisure",
      image: "/images/experience-leisure.jpg",
      description: "No matter if you're in your 20s or your 60s — if you're physically fit, eager to grow, and hungry to learn — I urge you to travel. Go as far and as wide as you can. Sleep on floors if you must. Discover how people live, eat, and cook in different corners of the world. Learn from them — wherever you go.",
      location: "Just 121 kilometers from Goa lies Amboli, a hidden gem nestled in the Western Ghats. One of the closest hill stations to Goa, Amboli enchants visitors with its pristine waterfalls, ancient temples, and breathtaking sunrise and sunset points. Whether you're seeking a quiet retreat or a romantic getaway, Amboli is a perfect escape into nature's embrace."
    },
    {
      title: "Go Adventure",
      image: "/images/experience-snow.jpg",
      description: "Chopta, located in the Rudraprayag district of Uttarakhand, is a paradise for trekkers and nature lovers. Fondly known as the \"Mini Switzerland of India,\" Chopta offers a wide range of trekking and exploration opportunities, attracting more visitors with each passing year.",
      location: "Just a short uphill trek of about 2 km from the village of Sari on the Ukhimath–Chopta road lies the serene Deoria Tal — a crystal-clear lake that reflects the majestic Chaukhamba peaks. Perched at an elevation of 2,438 meters, the valley is rich in flora and fauna, with dense forests of oak, deodar, and rhododendron."
    },
    {
      title: "Importance to Ecotourism",
      image: "/images/experience-hammock.jpg",
      description: "Ecotourism is more than just travel — it's a conscious movement. It promotes responsible travel to natural areas while preserving the environment and uplifting local communities. By choosing ecotourism, you help protect biodiversity, support sustainable livelihoods, and experience nature in its purest form.",
      location: "Nestled in the lush greenery of Kerala, Konni offers an ideal ecotourism escape. Engage in eco-friendly activities like bowl boat riding (both short and long rides), and embark on a thrilling jeep safari from Konni to Kattathi to Chelikkal and back. Cap off your adventure with a stay at Tree Top Bamboo Huts, where nature surrounds you and sustainability meets comfort."
    },
    {
      title: "Go Responsible",
      image: "/images/experience-traveller.jpg",
      description: "Responsible travel means making mindful choices that align with sustainable tourism practices. It's about respecting the places you visit and ensuring your journey leaves a positive impact.",
      location: "Support the local economy by dining at local restaurants, buying handmade souvenirs, exploring local markets, and hiring local guides. When you choose local, you ensure your money directly benefits the community that welcomes you — not a distant corporation. It's a powerful way to show appreciation and give back to the people and culture hosting your adventure."
    }
  ];

  return (
    <section id="experience" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {experiences.map((experience, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img
                  src={experience.image}
                  alt={experience.title}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {experience.title}
                </h3>

                <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                  {experience.description}
                </p>

                <p className="text-gray-600 text-sm leading-relaxed">
                  {experience.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
